import { OmitType, PartialType } from 'nestjs-mapped-types';
import { field } from '../../fields';
import { NoteId } from '../id';

export class NoteTranslationDto {
	@field.String()
	lang!: string;

	@field.String({ nullable: true })
	name!: string | null;
}

export class NoteUpdateDto {
	@field.String({ trim: true, min: 1 })
	name!: string;

	@field.String({ array: true })
	synonyms!: string[];

	@field.String({ array: true, optional: true })
	images?: string[];

	@field.Bool({ optional: true })
	active?: boolean;

	@field.Obj(NoteTranslationDto, { array: true, optional: true })
	translations?: NoteTranslationDto[];

	@field.String({ optional: true })
	comment?: string;
}

export class NoteCreateDto extends NoteUpdateDto {
	@NoteId()
	id!: NoteId;
}

export class NoteImportDto extends PartialType(OmitType(NoteUpdateDto, ['comment'])) {
	@NoteId()
	id!: NoteId;

	@field.Obj(NoteTranslationDto, { array: true, optional: true })
	translations?: NoteTranslationDto[];
}
